import { TicketStatus, TicketType, TicketPriority } from '@/types';

export function StatusBadge({ status }: { status: TicketStatus }) {
  const cls: Record<TicketStatus, string> = {
    OPEN:        'open',
    IN_PROGRESS: 'in-progress',
    RESOLVED:    'resolved',
    CLOSED:      'closed',
  };
  return (
    <span className={`term-badge ${cls[status]}`}>
      {status.replace('_', ' ')}
    </span>
  );
}

export function TypeBadge({ type }: { type: TicketType }) {
  const cls: Record<TicketType, string> = {
    ISSUE:           'issue',
    SERVICE_REQUEST: 'service',
  };
  return (
    <span className={`term-badge ${cls[type]}`}>
      {type === 'ISSUE' ? 'ISSUE' : 'SVC REQ'}
    </span>
  );
}

export function PriorityBadge({ priority }: { priority: TicketPriority }) {
  const cls: Record<TicketPriority, string> = {
    LOW:    'low',
    MEDIUM: 'medium',
    HIGH:   'high',
  };
  return (
    <span className={`term-badge ${cls[priority]}`}>
      {priority}
    </span>
  );
}


